import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global error suppression for ResizeObserver - must be at the very top
(function() {
  const originalError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (
      typeof message === 'string' &&
      (message.includes('ResizeObserver loop completed with undelivered notifications') ||
       message.includes('ResizeObserver loop limit exceeded'))
    ) {
      return true; // Prevent default error handling
    }
    if (originalError) {
      return originalError.apply(this, arguments);
    }
    return false;
  };
})();

// Suppress ResizeObserver loop completed warnings
// This is a known issue with ResizeObserver and doesn't affect functionality
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('ResizeObserver loop completed with undelivered notifications') ||
     args[0].includes('ResizeObserver loop limit exceeded'))
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Handle unhandled promise rejections for ResizeObserver
window.addEventListener('error', (event) => {
  if (
    event.message &&
    (event.message.includes('ResizeObserver loop completed with undelivered notifications') ||
     event.message.includes('ResizeObserver loop limit exceeded'))
  ) {
    event.preventDefault();
    return false;
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason &&
    event.reason.message &&
    (event.reason.message.includes('ResizeObserver loop completed with undelivered notifications') ||
     event.reason.message.includes('ResizeObserver loop limit exceeded'))
  ) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
